import axios from 'axios';
import { getConfigEndpoint } from '../endpoints/configEndpointManager';
import { getAdminToken } from '../auth/authManager';

const createApiKeyClient = () => {
  const serviceEndpoint = getConfigEndpoint();

  if (!serviceEndpoint || serviceEndpoint === '') {
    throw new Error('Config service endpoint is not available. Please add endpoints in Public DNS Manager.');
  }

  const formattedEndpoint = serviceEndpoint && !serviceEndpoint.startsWith('http')
    ? `https://${serviceEndpoint}`
    : serviceEndpoint;

  const baseURL = formattedEndpoint ? `${formattedEndpoint}/admin-api/v1` : '/admin-api/v1';

  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 10000,
  });
};

const getAuthHeaders = () => {
  const token = getAdminToken();
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const apiKeyAPI = {
  getAll: async (params = {}) => {
    try {
      const client = createApiKeyClient();
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString ? `/api-keys?${queryString}` : '/api-keys';
      const response = await client.get(endpoint, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Failed to get API keys:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const client = createApiKeyClient();
      const response = await client.get(`/api-keys/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to get API key ${id}:`, error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const client = createApiKeyClient();
      const response = await client.post('/api-keys', data, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Failed to create API key:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const client = createApiKeyClient();
      const response = await client.put(`/api-keys/${id}`, data, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to update API key ${id}:`, error);
      throw error;
    }
  },

  rotate: async (id) => {
    try {
      const client = createApiKeyClient();
      const response = await client.post(`/api-keys/${id}/rotate`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to rotate API key ${id}:`, error);
      throw error;
    }
  },

  revoke: async (id) => {
    try {
      const client = createApiKeyClient();
      const response = await client.post(`/api-keys/${id}/revoke`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to revoke API key ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const client = createApiKeyClient();
      const response = await client.delete(`/api-keys/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Failed to delete API key ${id}:`, error);
      throw error;
    }
  },

  getStats: async () => {
    try {
      const client = createApiKeyClient();
      const response = await client.get('/api-keys/stats', {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Failed to get API key stats:', error);
      throw error;
    }
  }
};